import { render, staticRenderFns } from "./ConverGCoins.vue?vue&type=template&id=bfb98b4c&scoped=true"
import script from "./ConverGCoins.vue?vue&type=script&lang=js"
export * from "./ConverGCoins.vue?vue&type=script&lang=js"
import style0 from "./ConverGCoins.vue?vue&type=style&index=0&id=bfb98b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb98b4c",
  null
  
)

export default component.exports